import { TypedDocumentNode, gql } from '@apollo/client';

import { isType } from '@sorare/core/src/lib/gql';

import { TransactionsPrimaryOffer } from '../../common/TransactionsPrimaryOffer';
import { TransactionsPrimaryOfferTitle } from '../../common/TransactionsPrimaryOffer/Title';
import { AccountEntry } from '../AccountEntry';
import type { PrimaryOffer_authorizationRequest } from './__generated__/index.graphql';

type Props = {
  payment: PrimaryOffer_authorizationRequest;
};

export const PrimaryOffer = ({ payment }: Props) => {
  const { operation } = payment;

  if (!isType(operation, 'TokenPrimaryOffer')) {
    return null;
  }

  return (
    <AccountEntry
      payment={payment}
      title={<TransactionsPrimaryOfferTitle tokenPrimaryOffer={operation} />}
    >
      <TransactionsPrimaryOffer tokenPrimaryOffer={operation} />
    </AccountEntry>
  );
};

PrimaryOffer.fragments = {
  payment: gql`
    fragment PrimaryOffer_authorizationRequest on AuthorizationRequest {
      id
      ...AccountEntry_authorizationRequest
      operation {
        ... on TokenPrimaryOffer {
          id
          ...TransactionsPrimaryOffer_tokenPrimaryOffer
          ...TransactionsPrimaryOfferTitle_tokenPrimaryOffer
        }
      }
    }
    ${AccountEntry.fragments.payment}
    ${TransactionsPrimaryOffer.fragments.tokenPrimaryOffer}
    ${TransactionsPrimaryOfferTitle.fragments.tokenPrimaryOffer}
  ` as TypedDocumentNode<PrimaryOffer_authorizationRequest>,
};
